import axios from 'axios';

export const getActivity = async (activityId) => {
  const { data } = await axios.get(`/activities/${activityId}/wp-info?base-url=${process.env.REACT_APP_WEB_DOMAIN}`);

  return data;
};
